/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Signup_Error_Taxpayer_Id_RequiredInputs */

const es_co2_signup_error_taxpayer_id_required = /** @type {(inputs: Signup_Error_Taxpayer_Id_RequiredInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`El NIT es obligatorio`)
};

/**

* @param {Signup_Error_Taxpayer_Id_RequiredInputs} inputs
* @param {{ locale?: "es-CO" }} options
* @returns {LocalizedString}
*/
export const signup_error_taxpayer_id_required = /** @type {((inputs?: Signup_Error_Taxpayer_Id_RequiredInputs, options?: { locale?: "es-CO" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Signup_Error_Taxpayer_Id_RequiredInputs, { locale?: "es-CO" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return es_co2_signup_error_taxpayer_id_required(inputs)
});